import {useSyncExternalStore} from 'react';

import {dragStore, selectEvents} from '../store/dragStore';

export const useEvents = () => useSyncExternalStore(dragStore.subscribe, selectEvents);
